import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import PageHeader from "./PageHeader";
import PageContent from "./PageContent";
import "./FacultiesDetails.css";
import data from "./Faculties.json";

export default function FacultyDetails() {
  const [activeTab, setActiveTab] = useState("details");
  const { id } = useParams();
  const [facultyData, setFacultyData] = useState(null);

  const [getFac, setGetFac] = useState();

  useEffect(() => {
    const vlaue = data.find((val) => val.id === id);

    setGetFac(vlaue);
  }, []);












  return (
    <div>
      {/* <PageHeader title={`${facultyData.name}`} /> */}
      <div className="profile-container">

        <div className="profile-main">

          <div className="profile-left">

            <div className="profile-photo">
              <img
                src={
                  "https://campus.acetians.in/custom/images/upload/manish_kannojia.jpg"
                }
                alt={"manish_kannojia"}
              />
            </div>
          </div>

          {/* Right Section */}
          <div className="profile-right">
            <div className="profile-info">
              <h2>{getFac?.personalDetails?.name}</h2>
              <p className="designation">
                Dr. Manish Kannojia
              </p>


              <div className="info-section">
                <p className="info-title">Designation</p>
                <p className="info-text">
                  Deputy Chief Proctor
                </p>
              </div>
            </div>
          </div>
        </div>


      </div>
      <div>
        

        <div className='contentarea' style={{background:"white"}}>
        
          <div className='sub-contentarea' style={{boxShadow:"none",padding:"none"}}>
            <div>
                <h1>E-Content </h1>
              <table>
                <thead>
                  <tr>
                    <th>SR NO.</th>
                    <th>Title</th>
                    <th>Link</th>
                  </tr>
                </thead>
                <tbody style={{ textTransform: "uppercase" }}>
                  <tr>
                    <td>1</td>
                    <td> ANALYSING CONSUMER BEHAVIOUR unit 2</td>
                    <td>
                      <a target="_blank" href="https://drive.google.com/file/d/1-TK-xhVtb3l1yF9Kp-G4caT-xESBeThE/view?usp=drive_web">Get Document</a>
                    </td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td> Basic Accounting MCQS</td>
                    <td>
                      <a target="_blank" href="https://drive.google.com/file/d/17_WtVg0PUeNa8D4-O8UhfYBc743PSVld/view?usp=drive_web">Get Document</a>
                    </td>
                  </tr>
                  <tr>
                    <td>3</td>
                    <td> Basic Accounting PPT</td>
                    <td>
                      <a target="_blank" href="https://drive.google.com/file/d/10eMEU9kSbKFddXF5vo9HEZUEVgLtEsxc/view?usp=drive_web">Get Document</a>
                    </td>
                  </tr>
                  <tr>
                    <td>4</td>
                    <td> basic-accounting PPT</td>
                    <td>
                      <a target="_blank" href="https://drive.google.com/file/d/1Nai-1UDl9XIO1Ndjbt2yYSsCq_oSEdBh/view?usp=drive_web">Get Document</a>
                    </td>
                  </tr>
                  <tr>
                    <td>5</td>
                    <td> business communication notes DR. MANISH</td>
                    <td>
                      <a target="_blank" href="https://drive.google.com/file/d/1o6yLKa8uaWdsXUyN4W_BxS1wShDuJkBM/view?usp=drive_web">Get Document</a>
                    </td>
                  </tr>
                  <tr>
                    <td>6</td>
                    <td> Business Communication Study Material notes In Hindi</td>
                    <td>
                      <a target="_blank" href="https://drive.google.com/file/d/1G9VzrGVvL0JV-ZqY8gBRZnMXFxf7uIhA/view?usp=drive_web">Get Document</a>
                    </td>
                  </tr>
                  <tr>
                    <td>7</td>
                    <td> BUSINESS ETHICS</td>
                    <td>
                      <a target="_blank" href="https://drive.google.com/file/d/1G9VzrGVvL0JV-ZqY8gBRZnMXFxf7uIhA/view?usp=drive_web">Get Document</a>
                    </td>
                  </tr>
                  <tr>
                    <td>8</td>
                    <td> company law NOTES</td>
                    <td>
                      <a target="_blank" href="https://drive.google.com/file/d/1OzFKziNNTkoWlfjXrcjKRjsfB0iujQ6o/view?usp=drive_web">Get Document</a>
                    </td>
                  </tr>
                  <tr>
                    <td>9</td>
                    <td> Computer Concepts and Applications</td>
                    <td>
                      <a target="_blank" href="https://drive.google.com/file/d/1L4xL5rCOlF3W_q7A7rlbUw2TcRLgDH9s/view?usp=drive_web">Get Document</a>
                    </td>
                  </tr>
                  <tr>
                    <td>10</td>
                    <td> Computerized Accounting BOOK WRITING</td>
                    <td>
                      <a target="_blank" href="https://drive.google.com/file/d/1N_6lB3isnSE4gxERbYbCwdRccxB49_Qo/view?usp=drive_web">Get Document</a>
                    </td>
                  </tr>
                  <tr>
                    <td>11</td>
                    <td> Direct Marketing & Digital Marketing</td>
                    <td>
                      <a target="_blank" href="https://drive.google.com/file/d/1Ml0qlzJ0KodAIzoYPd0EiDkOLn5k56Gv/view?usp=drive_web">Get Document</a>
                    </td>
                  </tr>
                  <tr>
                    <td>12</td>
                    <td> DR. MANISH KANNOJIA - e-content OF B.COM III CORPORATE ACCOUNTING</td>
                    <td>
                      <a target="_blank" href="https://drive.google.com/file/d/1PBA01guJMXCZjgxtMojluyV_0XQV5ctA/view?usp=drive_web">Get Document</a>
                    </td>
                  </tr>
                  <tr>
                    <td>13</td>
                    <td> Functional Areas of Management NOTES</td>
                    <td>
                      <a target="_blank" href="https://drive.google.com/file/d/1sEacrNVDzs3oxiUFQ9-4Wpym5ozTTBPv/view?usp=drive_web">Get Document</a>
                    </td>
                  </tr>
                  <tr>
                    <td>14</td>
                    <td> INCOME TAX summary</td>
                    <td>
                      <a target="_blank" href="https://drive.google.com/file/d/1qy86rA85SEJlY-icstTHHR8TM_IXIhyr/view?usp=drive_web">Get Document</a>
                    </td>
                  </tr>
                  <tr>
                    <td>15</td>
                    <td> Index Numbers NOTES</td>
                    <td>
                      <a target="_blank" href="https://drive.google.com/file/d/1u-yK9LrNxZ5J9jPCQtgbVHMycpVSOzdn/view?usp=drive_web">Get Document</a>
                    </td>
                  </tr>
                  <tr>
                    <td>16</td>
                    <td> MARKETING MANAGEMENT</td>
                    <td>
                      <a target="_blank" href="https://drive.google.com/file/d/1Wa-5Q79WwTIegh5P-wFksFQbvGsTe88_/view?usp=drive_web">Get Document</a>
                    </td>
                  </tr>
                  <tr>
                    <td>17</td>
                    <td> Organizational Behavior (OB) NOTES</td>
                    <td>
                      <a target="_blank" href="https://drive.google.com/file/d/1hJuOfJT4XXVvBxbI6llv-B1UCPjJuk9k/view?usp=drive_web">Get Document</a>
                    </td>
                  </tr>
                  <tr>
                    <td>18</td>
                    <td> Organizational Behavior</td>
                    <td>
                      <a target="_blank" href="https://drive.google.com/file/d/1Fe4IYJ6NxxDYsBBxVhVl-s8M2TFDEykr/view?usp=drive_web">Get Document</a>
                    </td>
                  </tr>
                  <tr>
                    <td>19</td>
                    <td> व्यावसायिक पर्यावरण.docx</td>
                    <td>
                      <a target="_blank" href="https://drive.google.com/file/d/1JPhchDJoONLH231-ygnsOM80RUzSe2kM/view?usp=drive_web">Get Document</a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>



      </div>
    </div>
  )
}